// A heat-load spec row before a heater has been chosen for it. SSRElements
// built this literal inline when adding a row; the part-number picker needs the
// same shape to clear a row back to unanswered.
export const makeBlankSpec = () => ({
  elementName: '',
  partNumber: '',
  currentCurrent: '',
  current: '',
  wattage: '',
  voltage: '',
  lengths: '',
});
